import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import {
  getField,
  getSessionId,
  getSessionKey,
  getActivated,
  makeGetTextFor,
} from '../../selectors';
import ReactSelectWrapper from '../ReactSelectWrapper';
import { clioSearchRequest } from '../../api';

class ClioTableSelector extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    onChange: PropTypes.func.isRequired,
    renderLabel: PropTypes.func.isRequired,
    renderRequired: PropTypes.func.isRequired,
    renderWarnings: PropTypes.func.isRequired,
    field: PropTypes.object.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.object,
    ]).isRequired,
    sessionId: PropTypes.string.isRequired,
    sessionKey: PropTypes.string.isRequired,
    activated: PropTypes.bool.isRequired,
    getTextFor: PropTypes.func.isRequired,
    inline: PropTypes.bool.isRequired,
  }

  // defaultOptions lets us cache the returned value from the async call so that we can continue presenting
  // it to the user even if they click away, or clear, their input.
  constructor(props) {
    super(props);

    this.state = {
      defaultOptions: null,
    };
  }

  handleChange = (e) => {
    // This is needed if the user intentionally clears the value.
    this.props.onChange(e === null ? null : e.value);
  }

  getClioData = (inputValue, callback) => {
    const { sessionId, sessionKey, field } = this.props;
    const tableOptions = field.get('tableOptions');

    const success = (searchResults) => {

      const defaultOptions = searchResults.data.map((datum) => {
        const label = `${datum.id} - ${tableOptions.get('entity_type') === 'contacts' ? datum.name : datum.description}`;

        return { label, value: datum };
      });

      this.setState({ defaultOptions });

      return callback(defaultOptions);
    };

    const failure = (message) => {
      if (this.props.activated) {
        alert(this.props.getTextFor('validations.there-was-an-error-refresh'));
      } else {
        alert(`${this.props.getTextFor('validations.there-was-an-error')}: ${message}`);
      }

      return callback([]);
    };

    return clioSearchRequest(sessionId, sessionKey, inputValue, tableOptions.get('immutable_variable_name'), success, failure);
  }

  getSelectedValue = () => {
    const { value, field } = this.props;
    const tableOptions = field.get('tableOptions');

    if (!value) return null;

    const entityType = tableOptions.get('entity_type');
    const label = `${value.get('id')} - ${value.get(entityType === 'contacts' ? 'name' : 'description')}`;

    return { label, value };
  }

  renderInput = () => {
    // See https://github.com/JedWatson/react-select/issues/614 for info on debouncing/throttling react-select async data
    const throttledGetClioData = throttle((inputValue, callback) => this.getClioData(inputValue, callback), 500);

    return (
      <React.Fragment>
        <ReactSelectWrapper
          selectedValue={this.getSelectedValue()}
          onChange={this.handleChange}
          asyncOptions={throttledGetClioData}
          defaultOptions={this.state.defaultOptions}
          async
        />
      </React.Fragment>
    );
  }

  render() {
    if (this.props.inline) {
      return (
        <span className="page-block__inline-wrapper">
          {this.props.renderRequired()}
          {this.renderInput()}
          {this.props.renderWarnings()}
        </span>
      );
    }

    return (
      <div className="page-block__field-wrapper">
        <div className="page-block__field-label">
          {this.props.renderLabel()}
          {this.props.renderRequired()}
        </div>
        <div className="page-block__field-input">
          {this.renderInput()}
          {this.props.renderWarnings()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const field = getField(state, ownProps.id);
  const sessionId = getSessionId(state);
  const sessionKey = getSessionKey(state);
  const activated = getActivated(state);

  return {
    field,
    sessionId,
    sessionKey,
    activated,
    getTextFor: makeGetTextFor(state),
  };
};

export default connect(mapStateToProps)(ClioTableSelector);
